import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AppDialog from './AppDialog';

export default function ProcessingCloseWarningDialog({ open, onStay, onCloseAnyway }) {
  const { t } = useTranslation();

  return (
    <AppDialog
      open={open}
      onClose={onStay}
      aria-labelledby="processing-close-warning-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="processing-close-warning-title">
        {t('common.processingClose.title')}
      </DialogTitle>
      <DialogContent dividers>
        <Typography>{t('common.processingClose.message')}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onStay}>{t('common.processingClose.stay')}</Button>
        <Button color="warning" variant="contained" onClick={onCloseAnyway}>
          {t('common.processingClose.closeAnyway')}
        </Button>
      </DialogActions>
    </AppDialog>
  );
}
